import { ReactNode } from "react";
import { usePrefixedNavigate } from "../hooks/usePrefixedNavigate";
import UserSection from "./UserSection";

interface DashboardLayoutProps {
  children: ReactNode;
  sidebarItems: { label: string; path: string; icon: ReactNode }[];
  currentPath: string;
}

export default function DashboardLayout({
  children,
  sidebarItems,
  currentPath,
}: DashboardLayoutProps) {
  const navigate = usePrefixedNavigate();

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Sidebar */}
      <aside className="fixed left-0 top-0 flex h-screen w-64 flex-col overflow-hidden border-r border-border bg-white shadow-sm">
        <div className="border-b border-border p-6">
          <h2 className="text-xl font-bold text-[#8B0000]">JBF Portal</h2>
        </div>
        <nav className="flex-1 space-y-2 overflow-y-auto p-4">
          {sidebarItems.map(item => (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex w-full items-center gap-3 rounded-lg px-4 py-3 transition-colors ${
                currentPath === item.path
                  ? "bg-[#8B0000] text-white"
                  : "text-muted-foreground hover:bg-muted"
              }`}
            >
              {item.icon}
              <span className="font-medium">{item.label}</span>
            </button>
          ))}
        </nav>
        <UserSection />
      </aside>

      {/* Main Content */}
      <div className="ml-64 flex min-h-screen min-w-0 flex-1 flex-col">
        {/* Top Header */}

        {/* Page Content */}
        <main className="min-w-0 flex-1 overflow-x-auto overflow-y-auto p-4 sm:p-6">
          {children}
        </main>
      </div>
    </div>
  );
}
